import type { ExistentialPillar } from '../stores/existentialPillarsStore';

/**
 * Existential meaning XP (EX3) — a DERIVED view of the spiritual/existential
 * practice system, credited to the Existential domain. The `existential_pillars`
 * ledger is the canonical sink: it already aggregates ALL three earners —
 * practice activities (via `logActivity`'s pillar fan-out), Reflections
 * (`ExistentialReflectionTab` → `addXP(pillar)`), and Quran Mastery — so summing
 * the ledger's per-pillar XP is exactly the domain credit, with no double-count
 * (each earning event credits the ledger once; the secondary-pillar spread is
 * intentional, internally consistent across the radar and the domain).
 *
 * This is the SINGLE value `useUserStats` reads to credit the Existential domain
 * once (mirroring the Ecological finance / Intellectual learning pattern). A
 * Pillar's radar level also reads this ledger, so radar and domain stay aligned.
 *
 * NOTE: tagged actions (a future `practiceId` on tasks/habits/projects, EX3b) are
 * NOT funneled into the ledger — they already credit the domain through their
 * category sum, so keeping them out keeps this credit-once.
 */
export function computeExistentialDomainXP(pillars: ExistentialPillar[]): number {
  return pillars.reduce((sum, p) => sum + Math.max(0, p.xp || 0), 0);
}
